import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import ServiceCard from "../../components/ServiceCard/ServiceCard";

import "./Services.css";

const Services = ({ innerRef }) => {
	const navigate = useNavigate();

	const { t } = useTranslation();
	const items = t("services.items", { returnObjects: true }).slice(0, 3);

	const handleNavigation = (page, serviceId) => {
		if (window.location.pathname === "/" + page) {
			window.location.reload();
		} else if (window.location.pathname === "/" && page === " ") {
			window.location.reload();
		} else {
			navigate("/" + page, {
				state: {
					serviceId: serviceId,
				},
			});
		}
	};

	return (
		<div id="home-services" ref={innerRef} className="services-bg">
			<h2 className="services-title">{t("services.title")}</h2>

			<div className="services-container">
				{items.map((item, index) => (
					<ServiceCard
						key={index}
						data={{
							id: index,
							icon: item["icon"],
							alt: item["alt"],
							name: item["titleSmall"],
							description: item["descriptionSmall"],
							buttonMore: t("services.buttonMore"),
						}}
						handleClick={() => handleNavigation("servicios", index.toString())}
					/>
				))}
			</div>
		</div>
	);
};

export default Services;
